import { render, staticRenderFns } from "./dispatch_bookings_driver_bid_board_tbn.vue?vue&type=template&id=cf1ecce0&scoped=true&"
import script from "./dispatch_bookings_driver_bid_board_tbn.vue?vue&type=script&lang=js&"
export * from "./dispatch_bookings_driver_bid_board_tbn.vue?vue&type=script&lang=js&"
import style0 from "./dispatch_bookings_driver_bid_board_tbn.vue?vue&type=style&index=0&id=cf1ecce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1ecce0",
  null
  
)

export default component.exports